/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { LicenseManager } from "ag-grid-enterprise";
import * as UtilsHelper from "../../../../../../utils/utilsHelper";
import { useTranslation } from "react-i18next";
import ActionButtonRenderer from "../FileSharingDoc/ActionButtonRenderer";
import IconRenderer from "./IconRenderer";
import _ from "underscore";

const SharedUserDisplay = (props) => {
  const { t } = useTranslation();
  const { existingUsersList } = props;
  const gridRef = useRef();

  const { fullDateTimePattern, dateLocale } = useSelector(
    (store) => store.template
  );
  const { isAggridLoading, isBindersLoader, documentVersionList } = useSelector(
    (store) => store.document
  );
  let { apiInitConfigObj } = useSelector((store) => store.zone);

  const aggridKey = atob(apiInitConfigObj.aggridaccess);
  LicenseManager.setLicenseKey(aggridKey);

  let latestData = [];
  useEffect(() => {
    if (existingUsersList !== undefined && existingUsersList !== null) {
      existingUsersList.map((users, i) => {
        let bindersCreatedOn =
          users.binderCreatedOn && fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                users.binderCreatedOn,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(users.binderCreatedOn, true);

        let recipientsList = [];
        if (users.recipients.length >= 1) {
          users.recipients.map((names) => {
            recipientsList.push(names);
          });
        }

        let coSignList = [];
        if (users.coSignatories.length >= 1) {
          users.coSignatories.map((sign) => {
            coSignList.push(sign);
          });
        }

        let documentVersion = users.documentsystemversion;
        let bindersDate = bindersCreatedOn;
        let recipientName = recipientsList;
        let coSignatory = users.requiredCoSingnatory ? coSignList : "-";
        let signCount = users.requiredSignature ? users.signedCount : "-";
        let viewcount = users.viewedCount;
        let status = users.sharingStatus;
        let sharingBinderId = users.sharingBinderId;
        let uniqueBinderId = users.binderId;

        latestData.push({
          ...users,
          recipientsName: recipientName,
          coSignatoriesName: coSignatory,
          documentVersion: documentVersion,
          binderCreatedDate: bindersDate,
          viewedCount: viewcount,
          signedCount: signCount,
          status: status,
          sharingBinderId: sharingBinderId,
          binderId: uniqueBinderId,
        });
      });
      props.setOriginalRowData(latestData);
      props.setRowData(latestData);
    }
  }, [existingUsersList, props.resetRowData]);

  const checkLatestVersion = (props) => {
    const latestVersion = documentVersionList?.filter(
      (latest) => latest.islatestdocumentversion === true
    );
    if (!_.isEmpty(props) && !_.isEmpty(latestVersion)) {
      if (props.value === latestVersion[0]?.documentversionnumber) {
        return props.value;
      } else {
        return "versionCell";
      }
    } else return "";
  };
  const defaultColDefs = {
    resizable: true,
    headerHeight: "10px",
  };

  const defaultColState = [
    {
      headerName: t("TMF.LABEL_BINDERID"),
      field: "binderId",
      width: 95,
      sortable: true,
      pinned: "nopin",
      filter: true,
    },
    {
      headerName: t("TMF.LABEL_RECIPIENTS"),
      field: "recipientsName",
      flex: 1,
      sortable: true,
      pinned: "nopin",
      filter: true,
      tooltipField: "recipientsName",
    },
    {
      headerName: t("TMF.LABEL_COSIGNATORY"),
      field: "coSignatoriesName",
      flex: 1,
      filter: true,
      sortable: true,
      tooltipField: "coSignatoriesName",
    },
    {
      headerName: t("TMF.TEXT_VERSION"),
      field: "documentVersion",
      width: 75,
      cellClass: checkLatestVersion,
      filter: true,
      sortable: true,
    },
    {
      headerName: t("TMF.LABEL_CREATED"),
      field: "binderCreatedDate",
      pinned: "nopin",
      sortable: true,
      width: 175,
      filter: true,
    },
    {
      headerName: t("TMF.LABEL_VIEWED"),
      field: "viewedCount",
      pinned: "nopin",
      sortable: true,
      width: 75,
      filter: true,
    },
    {
      headerName: t("TMF.LABEL_SIGNED"),
      field: "signedCount",
      pinned: "nopin",
      sortable: true,
      width: 75,
      filter: true,
    },
    {
      headerName: t("TMF.LABEL_STATUS"),
      field: "status",
      cellRenderer: IconRenderer,
      pinned: "nopin",
      sortable: true,
      width: 75,
      filter: true,
    },
    {
      headerName: "",
      field: "sharingBinderId",
      pinned: "nopin",
      cellRenderer: ActionButtonRenderer,
      sort: false,
      width: 65,
      filter: false,
    },
  ];

  return (
    <>
      <div className="no-binder-section">
        <div
          className={
            isBindersLoader || isAggridLoading
              ? "no-binder-create"
              : "ag-grid-main-container"
          }
        >
          <div className="no-binder-head">
            <>
              <div
                className="ag-theme-alpine"
                style={{
                  width: "100%",
                  height: `calc(83vh - ${
                    isBindersLoader || isAggridLoading ? "365px" : "325px"
                  })`,
                }}
              >
                {isBindersLoader || isAggridLoading ? (
                  <div
                    className="d-flex align-center jc-center"
                    style={{ height: "100%", background: "#f3f3f3" }}
                  >
                    <viedoc-spinner />
                  </div>
                ) : (
                  <AgGridReact
                    suppressReactUi="true"
                    ref={gridRef}
                    rowData={props.rowData}
                    columnDefs={defaultColState}
                    defaultColDef={defaultColDefs}
                    suppressContextMenu={true}
                  ></AgGridReact>
                )}
              </div>
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default SharedUserDisplay;
